/**
 * This allows the selection of 1 or more values from a list of possible values.
 * It optionally allows constraining the selection to be a range.
 * It optionally allows constraining the selection to a single value.
 *
 * It's used within the library filters view.
 */

import * as preact from "preact";
import { useEffect, useRef, useState } from "preact/hooks";

interface Props {
  title: string;
  options: {
    value: string;
    label: string;
  }[];
  selectedValues: string[];

  onChange: (selectedValues: string[]) => void;
}

/**
 * Hook that alerts clicks outside of the passed ref
 */
const MultiSelectView: preact.FunctionComponent<Props> = (props: Props) => {
  const [expanded, setExpanded] = useState(false);

  const selectedValueSet = new Set(props.selectedValues);

  const wrapperRef = useRef(null);

  // Dismiss dropdown when clicking outside this component
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  return (
    <span
      class="customSelectLabel"
      onClick={() => setExpanded(!expanded)}
      ref={wrapperRef}
    >
      <span
        class="customSelect"
        onClick={() => {
          console.log("show multi select");
        }}
      >
        {props.title}
      </span>
      <i class="icon icon-sort"></i>
      {expanded ? (
        <div
          class="multiSelectDropdown"
          onClick={(event) => event.stopPropagation()}
        >
          <ul>
            {props.options.map((option) => (
              <li>
                <label>
                  <input
                    type="checkbox"
                    checked={selectedValueSet.has(option.value)}
                    onClick={() => {
                      if (selectedValueSet.has(option.value)) {
                        selectedValueSet.delete(option.value);
                      } else {
                        selectedValueSet.add(option.value);
                      }

                      console.log("selected values: ", selectedValueSet);
                      console.log(
                        "selected values: ",
                        Array.from(selectedValueSet)
                      );

                      props.onChange(Array.from(selectedValueSet));
                    }}
                  ></input>
                  &nbsp;{option.label}
                </label>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </span>
  );
};

export default MultiSelectView;
